export default __webpack_public_path__ + "static/media/Para_Site_LE.b120ea57.jpg";